export default __webpack_public_path__ + "static/media/img_db2-colorBkg.00656b0f.png";